import React from "react";
import { StoryblokComponent } from "@storyblok/react";

import IconArrowLeft from "@assets/svg/arrow-left.svg";
import IconArrowRight from "@assets/svg/arrow-right.svg";

import { ImageComparisonSliderProps } from "./types";
import * as Styled from "./styles";
import useImageComparisonSlider from "./hooks";

const ImageComparisonSlider: React.FC<ImageComparisonSliderProps> = ({
  items
}) => {
  const {
    emblaRef,
    prevButton,
    nextButton,
    scrollTo,
    scrollSnaps,
    selectedIndex
  } = useImageComparisonSlider();

  return (
    <Styled.Embla>
      <Styled.EmblaViewport ref={emblaRef}>
        <Styled.EmblaContainer>
          {items.map((item) => (
            <Styled.EmblaSlide key={item._uid}>
              <Styled.Button {...prevButton}>
                <IconArrowLeft />
              </Styled.Button>
              <StoryblokComponent blok={item} />
              <Styled.Button {...nextButton}>
                <IconArrowRight />
              </Styled.Button>
            </Styled.EmblaSlide>
          ))}
        </Styled.EmblaContainer>
      </Styled.EmblaViewport>

      <Styled.DotsWrapper>
        {scrollSnaps.map((key, index) => (
          <Styled.Button key={key} onClick={() => scrollTo(index)}>
            <Styled.Dot isActive={index === selectedIndex} />
          </Styled.Button>
        ))}
      </Styled.DotsWrapper>
    </Styled.Embla>
  );
};

export default ImageComparisonSlider;
